import styled from 'styled-components'
import { colors } from 'config/ui'

export const ModalFirstAccessSkin = styled.div`
  margin-left: 32px;
  margin-right: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const Title = styled.div`
  font-size: 26px;
  max-width: 424px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: bold;
  color: ${colors.black};
  margin-bottom: 8px;
  text-align: center;
`

export const Description = styled.div`
  font-size: 15px;
  line-height: 24px;
  color: #595a5c;
  margin-bottom: 32px;
  max-width: 424px;
  text-align: center;
  color: ${colors.black5};
`
export const DetailsBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 3px;
  border: solid 1px ${colors.black2};
  padding-top: 24px;
  margin-bottom: 40px;
  width: 288px;
  box-shadow: 0 0 12px 1px rgba(0, 0, 0, 0.06);
  border: solid 1px #f4f7fd;
`

export const Text = styled.div`
  font-size: 15px;
  color: ${colors.gray9};
  margin-bottom: 8px;
`
export const Code = styled.div`
  font-size: 40px;
  font-weight: 900;
  color: ${colors.gray9};
  margin-bottom: 24px;
`

export const Canvas = styled.canvas`
  position: absolute;
  display: none;
`

export const LinkToContinue = styled.div`
  width: 196px;
  height: 19px;
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.05px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  cursor: pointer;
  margin-bottom: 38px;
`
